module.exports = __webpack_public_path__ + "img/horizontal_7_7_8023.29c198b3.png";